
import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

interface AuthGuardProps {
  children: ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem('itsm-auth-token');
    
    if (!token) {
      toast.error('Please login to access this page');
      navigate('/login');
    }
  }, [navigate]);
  
  return <>{children}</>;
};
